module.exports = __webpack_public_path__ + "static/media/6.bc92a4b2.svg";